import { VwpPackageItemExtra } from "../types";

export const price = (number: number, showDecimal: boolean = true) => 
    // TODO change currency to be variable
    new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD', maximumFractionDigits: (showDecimal ? 2 : 0) })
        .format(number);

export function formatExtraLabel(extra: VwpPackageItemExtra, priceField: 'packagePrice' | 'rrpPrice', isSingle: boolean, isAdd: boolean = true) {
    const sign = isAdd ? '+' : '-';
    return `${extra.description} (${sign}${price(extra[ priceField ])}${isSingle ? '' : ' each'})`;
}

